import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { useEffect, useRef } from "react";
import { useStore } from "react-redux";

import "./style.scss";

function useSelectedNodeScroll(treeRef: any) {
  const store = useStore();
  const selectedNodeRef = useRef(null);

  useEffect(() => {
    // I know it looks weird - but this is a necessary hack: scroll the selected node into view *without re-rendering the tree*,
    // which stops the dropdown (also a tree node) from closing. That's why we need to use the store directly.
    const unsubscribe = store.subscribe(() => {
      const newSelected = getSelectedNode(store.getState() as any);
      if (newSelected?.id !== (selectedNodeRef.current as any)?.id) {
        (selectedNodeRef as any).current = newSelected;
        if (newSelected && treeRef.current) {
          const node = treeRef.current.get(newSelected.id);
          if (node) {
            let parent = node.parent;
            while (parent) {
              if (!parent.isOpen) parent.open();
              parent = parent.parent;
            }
            treeRef.current.scrollTo(newSelected.id);
          }
        }
      }
    });
    return unsubscribe;
  }, [store, treeRef]);
}

export default useSelectedNodeScroll;